// extracted by mini-css-extract-plugin
export default {"heading":"styles_heading__p1doe","imageWrapper":"styles_imageWrapper__nuQ-0","list":"styles_list__o5YLe"};